import { createSelector } from '@reduxjs/toolkit';
import { RootSelector } from '../../models/rootSelector';
import { GoogleBulkState } from './model';
import {
  getSelectedNodeIDsInAllFolders,
  getSelectedNodesInAllFolders,
} from '../fileManager/selectors/selectors';
import { CHNodeIsFolder } from '../../../general/node';

const getGoogleBulk: RootSelector<GoogleBulkState> = (store) => store.googleBulk;

export const getLinks = createSelector(getGoogleBulk, (googleBulk) => googleBulk.links);

export const getInProgress = createSelector(getGoogleBulk, (googleBulk) => googleBulk.inProgress);

export const getProgressValues = createSelector(
  getGoogleBulk,
  (googleBulk) => googleBulk.progressValues,
);

export const getHash = createSelector(getSelectedNodeIDsInAllFolders, (nodeIds) =>
  [...nodeIds].sort().join(),
);

export const getCurrentInfo = createSelector(
  [getLinks, getInProgress, getProgressValues, getSelectedNodeIDsInAllFolders],
  (links, inProgress, progressValues, nodeIds) => {
    const hash = [...nodeIds].sort().join();
    return {
      nodeIds,
      hash,
      link: links[hash],
      inProgress: inProgress[hash],
      progressValue: progressValues[hash],
    };
  },
);

export const getIsGoogleBulkButtonVisible = createSelector(
  [getSelectedNodesInAllFolders],
  (nodes) => {
    if (nodes.length === 1) {
      return CHNodeIsFolder(nodes[0]);
    }
    return nodes.length > 1;
  },
);
